// removed by extract-text-webpack-plugin
module.exports = {"content":"FullWidthRegion__content___3K3_j","seamless":"FullWidthRegion__seamless___2FzoF"};


//////////////////
// WEBPACK FOOTER
// ./application/js/components/FullWidthRegion.css
// module id = 519
// module chunks = 0